import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const deployStatusManager = {
  getDeployStatus(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default deployStatusManager;
